import React, { useEffect, useState } from "react";
import style from "./Home.module.css";

import './slickStyling.css';
import parse from 'html-react-parser';


import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation,Autoplay } from "swiper";

import "./datePicker.css";

import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import { useLocation, Link } from "react-router-dom";

import { useTranslation } from 'react-i18next';
import Loading from '../../components/Loading/Loading';
import { getCities, getHomeSections, getPropertyTypes, getWebsiteSettings } from '../../Api/commonApis';
import { getAreas } from './../../Api/commonApis';
import { getAreawithProperties, getHomeHeaders, getPropertiesByArea } from './../../Api/homeApis';
import BlogsSlider from './../../components/blogSLider/index';
import BrandsSlider from './../../components/brands/brandsSlider';
import arrow from '../../assets/icons/dropdownarrow.svg';
import phone from '../../assets/icons/phone.svg';
import whatsapp from '../../assets/icons/whatsapp.svg';
import {basename } from "../../configiration/config";
import noImage from '../../assets/images/noImage.png';
import { filterLanguage, filterProperties } from './../../utilities/filterFunction';
import logo from '../../assets/images/logo.png';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../pages/Home/slickStyling.css';
import Slider from "react-slick";
import { imgResize } from './../../utilities/imageResize';
function Home() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  var myDate = new Date();
  //add a day to the date
  myDate.setDate(myDate.getDate() + 1);
  const [typeDropHead, setTypeDropHead] = useState( t("property-type"));
  const [cityDropHead, setCityDropHead] = useState(t("area"));

  const [loadingPropperties, setloadingPropperties] = useState(true);
  const [loadingfacilties, setloadingfacilties] = useState(true);

  const [minCheckoutDate, setMinCheckoutDate] = useState(myDate);
  const [minDate] = useState(new Date());
  const [cities, setCities] = useState([]);
  const [types, setTypes] = useState([]);
  const [slider, setSlider] = useState([]);
  const [searchObj, setSearchObj] = useState({ area: '', type: '', guests: '', checkIn: '', checkOut: '' })
  const [brands, setbrands] = useState([]);
  const [allProperties, setAllproperties] = useState([])
  const [facilities, setfacilities] = useState([])
  const [areas, setAreas] = useState([]);
  const [areasProperties, setAreasProperties] = useState([]);
  const [areaSelected, setareaSelected] = useState('');
  const [websiteSettings, setwebsiteSettings] = useState({});



  // get website settings
  useEffect(() => {
    getWebsiteSettings().then((res) => {
      let settings = { ...websiteSettings }
      settings = res.data.data
      setwebsiteSettings(settings)
    })
    //swiper stop on hover
    let swiper_containers = document.querySelectorAll('.swiper-container');
    for (let i = 0; i < swiper_containers.length; i++) {
        swiper_containers[i].addEventListener('mouseover', function() {
            var swiper = this.swiper;
            swiper.autoplay.stop();
        });

        swiper_containers[i].addEventListener('mouseleave', function() {
            var swiper = this.swiper;
            swiper.autoplay.start();
        });
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getHomeSections().then((res) => {
      let data = res.data.data
      // get facilities 
      let facility = [...facilities];
      facility = data.facilities;
      setfacilities(facility);
      setloadingfacilties(false);
      //get slider
      let sliders = { ...slider }
      sliders = data.slider_images
      setSlider(sliders);
      //get leading brands
      let brand = [...brands]
      brand = data.leading_brands
      setbrands(brand);
    })
    // eslint-disable-next-line
  }, []);

  const [propertyHeaders,setpropertyHeaders]=useState();
  const [facilitiesHeaders,setfacilitiesHeaders]=useState();
  const [brandsHeaders,setbrandsHeaders]=useState();
  const [blogsHeaders,setblogsHeaders]=useState();
  
  useEffect(() => {
    // get home Data
    getHomeHeaders().then((res) => {
     let homeData = res.data.data;
      setpropertyHeaders(homeData.home_properties_section)
      setfacilitiesHeaders(homeData.home_facilities_section)
      setbrandsHeaders(homeData.home_leading_brands)
      setblogsHeaders(homeData.home_blog_section)
    })
    // eslint-disable-next-line
  }, []);

  // get cities
  useEffect(() => {
    getCities().then((res) => {
      let citiess = { ...cities }
      citiess = res.data.data
      setCities(citiess);
      // get all areas in city
      getAreas(citiess[0].slug).then((res) => {
        let area = { ...areas };
        area = res.data.data
        setAreas(area)
      })
      getAreawithProperties(citiess[0].slug).then((response)=>{
        let areas = { ...areasProperties };
        areas = response.data.data
        setAreasProperties(areas)
        setareaSelected(areas[0].slug)
      })
    })
    // eslint-disable-next-line
  }, []);

  // get types
  useEffect(() => {
    getPropertyTypes().then((res) => {
      let type = { ...types }
      type = res.data.data
      setTypes(type);
    })
    // eslint-disable-next-line
  }, []);

  //properties filter
  useEffect(() => {
    getPropertiesByArea(areaSelected).then((res) => {
      let property = { ...allProperties }
      property = res.data.data
      setAllproperties(property)
      setloadingPropperties(false)
    }).catch((err) => {
      setloadingPropperties(false)
    })
    // eslint-disable-next-line
  }, [areaSelected])

  function handleSelectOptions(e) {
    e.preventDefault();
    let search = { ...searchObj };
    if (e.target.name === 'area') {
      setCityDropHead(e.target.innerHTML)
      search[e.target.name] = { slug: e.target.id, name: e.target.innerHTML };
    }
    if (e.target.name === 'type') {
      setTypeDropHead(e.target.innerHTML)
      search[e.target.name] = { slug: e.target.id, name: e.target.innerHTML };
    }
    setSearchObj(search);
  }
  // handle inputs change
  function handleInputChange(e) {
    let search = { ...searchObj };
    if (e.target.name === 'guests' || e.target.name === 'checkIn' || e.target.name === 'checkOut') {
      search[e.target.name] = e.target.value;
    }
    setSearchObj(search);
  }

  function limitGuestNum(e){
    if(e.target.value > 30){
      e.target.value = 30
  }
  }
// facilties slider
var facilitiesSettings = {
  focusOnSelect: true,
  arrows: true,
  infinite: true,
  autoplay:true,
  speed: 300,
  slidesToShow: facilities.length >= 6 ? 6 : facilities.length,
  slidesToScroll:1,
  responsive: [
      {
          breakpoint: 1024,
          settings: {
              slidesToShow:facilities.length >= 4 ? 4 : facilities.length,
              slidesToScroll: 1,
              infinite: true,
          }
      },
      {
          breakpoint: 900,
          settings: {
              slidesToShow: facilities.length >= 3 ? 3 : facilities.length,
              slidesToScroll:1,
              infinite: true,
          }
      },
      {
          breakpoint: 500,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
          }
      }
  ]
};

  return (
    <div >
      {/* START OF HOME HEADER SLIDER*/}
      <div className={`${style.homeSlider} homeSlider`}>
        <div id="carouselExampleControls" className={`${style.HomeMainCarousel} carousel slide`} data-bs-ride="carousel">
          <div className="carousel-inner">
            {slider && slider.map((slide, i) => {
              let slides = filterLanguage(slide.locales)
              return (
                <div key={slide.slug} className={`carousel-item ${i === 0 && 'active'}`}>
                  <img src={`${imgResize(slide.image,1920,0)}`} className="d-block w-100" alt="..." onError={(e) => { e.target.src = noImage }} />
                  <div className={`  ${style.carouselCaption}`}>
                    <div className={`${style.homeLayer_content} mx-auto`}>
                      <h1>{slides.length && slides[0].title}</h1>
                      <p className={`w-75 mx-auto ${i18n.language === 'ar' ? style.carouselArabic :""}`}>
                        {slides.length && slides[0].description}
                      </p>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          <button
            className={`${style.BSCarouselBtn} carousel-control-prev`}
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className={`${style.BSCarouselBtn} carousel-control-next`}
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
        {/* START OF HOME HEADER CONTENT*/}
        <div className={`${style.homeLayer}`}>
        
          <div className={`${style.homeLayer_img}`}>
            {websiteSettings && websiteSettings.logo ? 
            <img src={`${imgResize(websiteSettings.logo,233,0)}`} onError={(e) => { e.target.src = logo }} alt="website logo" />
            :
            <img src={logo} alt="website logo" />
            }
          </div>

        </div>
        {/* END OF HOME HEADER CONTENT*/}
      </div>
      {/* END OF HOME HEADER SLIDER*/}

      {/* START OF SEARCH SECTION */}
      <div className={`${style.searchSection}`}>
        <div className={`${style.searchContainer} position-relative`}>
          <div className={`${style.searchElement}`}>
            <span>{t('location')}</span>
            <div className={`dropdown ${style.mates} searchInputs`}>
              <button
                className="w-100 btn px-2 d-flex justify-content-between align-items-center"
                type="button"
                id="cityDropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>{cityDropHead}</span>
                <img src={arrow} alt='arrow' />
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                {areas ? areas.map((city) => {
                  let selectedArea=city && city.locales && filterLanguage(city.locales)
                  return (
                    <li key={city.slug}>
                      <a href={selectedArea.length > 0 && selectedArea[0].name} className="dropdown-item" id={city.slug} name='area' onClick={handleSelectOptions}>{selectedArea.length && selectedArea[0].name}</a>
                    </li>
                  )
                })
                  :
                  <div>{t('no-data')}</div>
                }
              </ul>
            </div>
          </div>
          <div className={`${style.searchElement}`}>
            <span>{t('property-type')}</span>
            <div className={`dropdown ${style.mates} searchInputs`}>
              <button
                className="w-100 btn px-2 d-flex justify-content-between align-items-center"
                type="button"
                id="cityDropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>{typeDropHead}</span>
                {/* SELECT */}
                <img src={arrow} alt='arrow' />
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                {types ? types.map((type) => {
                  let selectedtype=type && type.locales && filterLanguage(type.locales)
                  return (
                    <li key={type.slug}>
                      <a href={selectedtype.length > 0 && selectedtype[0].name} className="dropdown-item" id={type.slug} name='type' onClick={handleSelectOptions}>{selectedtype.length && selectedtype[0].name}</a>
                    </li>
                  )
                }) :
                  <div>{t('no-data')}</div>
                }
              </ul>
            </div>
          </div>
         
          <div className={`${style.searchElement}`}>
            <span>{t('check-in')}</span>
            <DatePickerComponent name='checkIn' onFocus={e => e.target.blur()} className={`dropdown ${style.mates} e-input-group `} id="datepicker" format="E, d MMM y" min={minDate} onClick={(e) => { setMinCheckoutDate(e.target.value) }} onChange={handleInputChange} />
          </div>
          <div className={`${style.searchElement}`}>
            <span>{t('check-out')}</span>
            <DatePickerComponent name='checkOut' onFocus={e => e.target.blur()} className={`dropdown ${style.mates} e-input-group `} id="datepicker2" format="E, d MMM y" min={minCheckoutDate} onChange={handleInputChange} />
          </div>
          <div className={`${style.searchElement}`}>
            <span>{t('guests')}</span>
            <div className={`dropdown ${style.mates} position-relative searchInputs`}>
              <input className='guestsInputFiled' type="number" name='guests' min='1' max='30' onInput={limitGuestNum} placeholder={t('number-guests')} onChange={handleInputChange} />

            </div>
          </div>
          <div className={`${style.searchElement} ${style.SearchBtn} `}>
            <Link to={`${basename}/search-results`} state={{ searchObject: searchObj }} className={`w-100 searchInputs`}>
              {t('search')}
            </Link>
          </div>
        </div>
      </div>
      {/* END OF SEARCH SECTION */}

      <div>
        {/* START OF properties SECTION */}
        <div className={`${style.holidayHomes} mt-3`}>
          {propertyHeaders && propertyHeaders.locales && 
            <>
              <h2 className={style.sectionTitle}>{filterLanguage(propertyHeaders.locales)[0].title}</h2>
              <p className={style.sectionSubTitle}>{filterLanguage(propertyHeaders.locales)[0].description}</p>
            </>
          }
       
          <ul className={`d-flex nav-pills w-100  ${style.homesBtns} d-flex flex-align-center justify-content-center`} >
            {areasProperties ? areasProperties.map((area, i) => {
              let selectedArea=area && area.locales && filterLanguage(area.locales)
              return (
                <li key={area.slug} className="nav-item">
                  <button onClick={() => setareaSelected(area.slug)} className={`nav-link ${style.popularAreas} ${areaSelected === area.slug && 'active'}`}  >
                  {selectedArea.length > 0 ? selectedArea[0].name : ''}
                  </button>
                </li>
              )
            }) :
              <div>{t('no-data')}</div>
            }
          </ul>
          <div style={{ width: '90%', margin: 'auto', marginTop:'40px' }} className='position-relative'>
            <Swiper
              spaceBetween={20}
              slidesPerView={2}
              navigation={allProperties.length > 0  ? true :false}
              className={`swiper-container holidaySwiper`}
              autoplay={{
                disableOnInteraction: true,
              }} 
              modules={[Navigation,Autoplay]}
              breakpoints={{
                1050: {
                  slidesPerView: 2
                },
                800: {
                  slidesPerView: 2
                },
                700: {
                  slidesPerView: 1
                },
                500: {
                  slidesPerView: 1
                },
                300: {
                  slidesPerView: 1
                },
                200: {
                  slidesPerView: 1
                }
              }}
            >
              {allProperties && allProperties.length > 0 ? allProperties.map((property) => {
              let selectedProperty = filterLanguage(property.locales)
              let lang;
              if(i18n.language === 'ar'){
                lang = 'en'
              }else if(i18n.language === 'en'){
                lang = 'ar'
              }
              let diferentLanguage = filterProperties(property.locales,lang)
                return (
                  <SwiperSlide key={property.slug}>
                    <div className={`${style.itemContainer} h-100 swiperTest`}>
                      <div className={`${style.holidayItem2}`} >
                        <div className={`${style.holidayCard} ${style.no1} card h-100`}>
                          <div className={`${style.holidayCardImgContainer}`}>
                            <Link to={`${basename}/property-details/${property.slug}`} state={{propertyId:property}}>
                              <div className={`${style.holidayCardImgNested}`}>
                                <img
                                  src={`${imgResize(property.image,800,0)}`}
                                  className={`${style.holidayCardImg} card-img-top ${i18n.language === 'ar' && style.holidayCardRight}`}
                                  alt="..."
                                  onError={(e) => { e.target.src = noImage }}
                                />
                                <div className={`${style.overlayer} ${i18n.language === 'ar' && style.overLayRight}`}></div>
                                <div className={`${style.holidayCardContent}  ${i18n.language === 'ar' && style.overLayRight}`}>
                                  {property.facilities && property.facilities.length > 0 &&
                                    property.facilities.slice(0,6).map((faclity) => {
                                    let selectedFacilty = filterLanguage(faclity.locales)
                                      return (
                                        <div key={faclity.slug} className={`${style.homeOptions}`}>
                                          <span className={`${style.popup}`}>{selectedFacilty.length && selectedFacilty[0].name}</span>
                                          <img src={`${imgResize(faclity.image,50,50)}`} alt={faclity.slug} />
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>
                            </Link>
                          </div>
                          <div
                            className={`${style.cardBody} card-body pt-0`}
                          >
                            <Link to={`${basename}/property-details/${property.slug}`} state={{propertyId:property}} 
                            className={`card-title  mb-0 ${style.myCardTitle}`}>
                            {selectedProperty.length === 0 ? (diferentLanguage[0].title ): selectedProperty[0].title}
                            </Link>
                            <div
                              className={`${style.numbersDetails} myNumbersDetails d-flex align-items-center justify-content-between`}
                            >
                              <span> 
                              {property.space !==0 ? 
                                <span>{property.space} {t('meter')}<sup>2</sup> / </span>
                                :""
                              }
                                <span>{property.person} {t('person')}</span>
                               </span>
                              {property.price ?
                                <span>
                                  <span className={`${style.fromWord}`}>{t('from')} </span>
                                  <span className={`${style.price}`}>{property.price} AED</span>
                                </span>
                             :<div></div> }
                            </div>
                            <div className={`card-text ${style.myCardText}`}>
                              {selectedProperty.length === 0 ? (diferentLanguage[0].title ) : selectedProperty[0].short_description !== null && parse(selectedProperty.length && selectedProperty[0].short_description)}
                            </div>
                            <Link to={`${basename}/property-details/${property.slug}`} state={{propertyId:property}}>
                              <button>{t('book-now')}</button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                )
              })
                :
                !loadingPropperties &&
                <div className='text-danger h-100 mb-5 mt-5'>{t('no-data')}</div>
              }
              {loadingPropperties &&
                <Loading width='100px' height='100px' />
              }
            </Swiper>
          </div>
        </div>
        {/* END OF properties SECTION */}


        {/* START OF FACILITIES HOMES SECTION */}
        <div className={`${style.facilities}`}>
          {facilitiesHeaders && facilitiesHeaders.locales && 
          <>
            <h2 className={`${style.sectionTitle}`}>{filterLanguage(facilitiesHeaders.locales)[0].title}</h2>
            <p className={style.sectionSubTitle}>{filterLanguage(facilitiesHeaders.locales)[0].description}</p>
          </>
          }
          <Slider {...facilitiesSettings} className={`${style.facilitiesIcons} facilitiesSlider`}>
          {facilities && facilities.length > 0 ? facilities.map((facilty) => {
            let selectedFacilty = filterLanguage(facilty.locales)
            return (
              <div key={facilty.slug} className={`${style.facilityIcon}`}>
              <div className='d-flex justify-content-center align-items-center'>
                  <img src={`${imgResize(facilty.image,70,70)}`} alt={selectedFacilty.length && selectedFacilty[0].name} onError={(e) => { e.target.src = noImage }} />
              </div>
                <span>{selectedFacilty.length && selectedFacilty[0].name}</span>
              </div>
            )
          }) :
            !loadingfacilties &&
            <div>{t('no-data')}</div>
          }
          </Slider>
        </div>
        {/* END OF FACILITIES HOMES SECTION */}

        {/* START OF blogs SECTION */}
        <BlogsSlider blogHeader={blogsHeaders} hideBackLayer={false}/>
        {/* END OF TODO SECTION */}

        {/* START OF BRANDS SECTION */}
        <BrandsSlider brandsHeader={brandsHeaders} brands={brands}/>
        {/* END OF BRANDS SECTION */}
      </div>

      {/* Fixed Buttons */}
      <div className={` ${style.fixedButtons} ${i18n.language === 'en' ? style.buttonsRight : style.buttonsleft}  d-flex flex-column align-items-baseline justify-content-center`}>
        <button className={`${style.phone} rounded-pill`}>
          <a href={`tel:${websiteSettings.phone}`} className='d-flex text-align-center align-items-center justify-content-start'>
            <img src={phone} alt='phone' />
            <span>{t('contact-us')}</span>
          </a>
        </button>
        <button
          className={`${style.whats} rounded-pill d-flex align-items-center justify-content-center`}
        >
          <a
            href={`https://api.whatsapp.com/send?phone=${websiteSettings.whatsapp}`}
            target="_blank" rel="noreferrer"
          >
            <img src={whatsapp} alt='whatsapp' />
            <span>{t('whatsapp')}</span>
          </a>
        </button>
      </div>

    </div>
  );
}

export default Home;